import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { NgZone } from "@angular/core";

type OS = "ios" | "android" | "windows" | "macos" | "web" | undefined;

declare global {
    interface Window {
        /**
         * order-goをモバイルアプリのWebViewで動かすときに、
         * いくつかのイベントをWebView側でフックする。
         * モバイルアプリのフレームワークに依存させないために、こちら側でインターフェースを定義する。
         * モバイルアプリではWebViewの機能を使ってJavaScriptをinjectし、windowシングルトンにこれらのインターフェースを実装させる。
         */
        mobileApp: {
            os: OS
            setBadgeCount: (count: number) => void;
            login: (userId: number) => void;
            logout: (userId: number) => void;
            fileDownload: (downloadUrl: string, filename: string) => void;
        } | undefined;
        /**
         * モバイルアプリ側からWeb側に情報を渡したい場合、モバイルアプリ側でWebViewの機能を使ってJavaScriptをinjectしてこのオブジェクトのメソッドを呼び出す。
         */
        webApp: {
            goto: (path: string) => void;
        }
    }
}

/**
 * order-goをモバイルアプリのWebViewで動かすときに、
 * モバイルアプリ側に情報を送信する関数。
 */
@Injectable()
export class MobileAppService {
    constructor(
        private ngZone: NgZone,
        private router: Router,
    ) {
        window.webApp = {
            goto: (path) => {
                ngZone.run(() => {
                    router.navigateByUrl(path);
                })   
            }
        }
    }
    /**
     * モバイルアプリのアイコンにつく通知数のバッジを変更する。
     */
    setBadgeCount(count: number) {
        window.mobileApp?.setBadgeCount(count);
    }

    /**
     * 通知の設定のために、ログインをモバイルアプリに通知する。
     */
    login(userId: number) {
        window.mobileApp?.login(userId);
    }

    /**
     * 通知の解除のためにログアウトをモバイルアプリに通知する。
     */
    logout(userId: number) {
        window.mobileApp?.logout(userId);
    }

    /**
     * モバイル側でファイルをダウンロードする
     */
    fileDownload(downloadUrl: string, filename: string) {
        window.mobileApp?.fileDownload(downloadUrl, filename);
    }

    /**
     * OSの判断
     */
    os(): OS {
        return window.mobileApp?.os;
    }
}
